import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
// Service
import { ViewsService } from '../../../../../../services/views.service';
import { ScrollableItemsHelperOsService } from '../../../../../services/scrollable-items-helper-os.service';
// Model
import { ScrollableItemModel } from '../../../../../models/extended-section-options';
import { LayoutRenderLayoutItem } from '../../../../models/cv-layout-render.model';
import { RoomLayoutOptions } from '../../../models/components.options';

@Component({ template: '' })
export abstract class RoomLayoutBaseComponent {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();

	options = new RoomLayoutOptions();
	itemDirectiveData: ScrollableItemModel;
	path: any = null;

	get order(): any {
		return this.viewsService.order;
	}

	get itemId(): any {
		return `${this.data._Data.section}-${this.data._Data.index.join('-')}`;
	}

	get title(): string {
		let text = null;

		if (this.options.header) {
			if ('value' in this.options.header) {
				text = this.options.header.value;
			}

			if ('key' in this.options.header) {
				text = this.data[this.options.header.key];
			}
		}

		return text;
	}

	get cssClass(): string {
		let css = '';
		if (this.options.cssClass) {
			css = this.options.cssClass;
		}

		if (this.options.outerCssClass) {
			css += ' ' + this.options.outerCssClass;
		}

		return css;
	}

	protected atComponentDestroy = new Subject();

	constructor(
		protected viewsService: ViewsService,
		protected scrollableHelper: ScrollableItemsHelperOsService
	) {
		//
	}

	init(): void {
		this.options = { ...this.options, ...this.layoutNode.options };
		this.itemDirectiveData = this.scrollableHelper.getScrollableItem(this.data._Data.section, this.itemId);
		this.path = this.data._Path;
	}
}
